import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorNotificationCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M15 18.998a3 3 0 1 1-6 0c0-1.658 1.343-.75 3-.75s3-.908 3 .75Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 1a1 1 0 0 0-1 1v1.325a6.585 6.585 0 0 0-5.583 6.508v3.492l-2.35 2.468c-1.062 1.114-.272 2.957 1.266 2.957h15.334c1.538 0 2.328-1.843 1.267-2.957l-2.35-2.468V9.833A6.585 6.585 0 0 0 13 3.325V2a1 1 0 0 0-1-1ZM6.917 9.833a5.083 5.083 0 0 1 10.166 0v4.092l2.765 2.903a.25.25 0 0 1-.181.422H4.333a.25.25 0 0 1-.18-.422l2.764-2.903V9.833Z"
    />
  </svg>
);
export default SvgTwoColorNotificationCenter;
